import { Divider, IconButton, ListItemIcon } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import React, { Component } from "react";
import * as u from "./ActionItems";
import { ActionMenuItem } from "./ActionMenuItem";

class ActionMenu extends Component {
  state = {
    row: this.props.row,
    anchorEl: null,
    dialogOpen: false,
    actionItems: []
  };

  componentDidMount() {
    const actionList = u.actionMap.get(this.props.tabletype);
    if (actionList && typeof actionList == "function") {
      Promise.resolve(actionList(this.props.row))
        .then((items) => this.setState({ actionItems: items }))
        .catch((err) => console.log(err))
    } else {
      this.setState({ actionItems: actionList })
    }
    this.setState({ row: this.props.row });
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleDialogOpen = (event) => {
    this.setState({ dialogOpen: event.currentTarget.dataset.dialog });
    this.handleClose();
  };

  handleDialogClose = () => {
    // console.log("object");
    this.setState({ dialogOpen: null });
    this.handleClose();
  };

  isDisabled() {
    if (
      this.state.actionItems &&
      this.state.actionItems.find((action) =>
        typeof action.canShow == "function"
          ? action.canShow(this.props.row)
          : true
      )
    ) {
      return false;
    } else {
      return true;
    }
  }

  getColor() {
    if (this.isDisabled()) {
      return "disabled";
    } else {
      return "primary";
    }
  }

  renderAction = (action, idx) => {
    switch (true) {
      case Boolean(action && action.divider):
        return <Divider key={`divider-${idx}`} />;

      case Boolean(action && action.mainMenu):
        const mainMenuItems = [
          <MenuItem key={`menuitem-${idx}`} disabled className="overwrite">
            <ListItemIcon className="smaller-list-item-icon mainmenu">
              {action.icon ? (
                action.icon
              ) : (
                <KeyboardArrowRightIcon
                  fontSize="small"
                  color="secondary"
                />
              )}
            </ListItemIcon>
            {action.mainMenu}
          </MenuItem>,
          <Divider key={`divider-after-${idx}`} />,
          ...(action.subMenus
            ? action.subMenus.map((a, sidx) => (
              <ActionMenuItem
                key={`sub-${idx}-${sidx}`}
                action={a}
                handleDialogOpen={this.handleDialogOpen}
                dialogOpen={this.state.dialogOpen}
                handleDialogClose={this.handleDialogClose}
                props={this.props}
                subMenu={true}
              />
            ))
            : [])
        ];
        return mainMenuItems;

      case Boolean(action && action.isnavlink):
        return (
          <MenuItem key={`action-${idx}`}>
            <ListItemIcon className="smaller-list-item-icon">
              {action.icon ? (
                action.icon
              ) : (
                <KeyboardArrowRightIcon fontSize="small" color="primary" />
              )}
            </ListItemIcon>
            {action.navlink(this.props)}
          </MenuItem>
        );

      default:
        return (
          <ActionMenuItem
            key={`action-${idx}`}
            action={action}
            handleDialogOpen={this.handleDialogOpen}
            dialogOpen={this.state.dialogOpen}
            handleDialogClose={this.handleDialogClose}
            props={this.props}
            subMenu={false}
          />
        );
    }
  };

  render() {
    const menuItems = this.state.actionItems && this.state.actionItems
      .filter((action) =>
        typeof action.canShow == "function"
          ? action.canShow(this.props.row)
          : true
      )
      .map((action, idx) => this.renderAction(action, idx))
      .flat(); // Flatten arrays from mainMenu items

    return (
      <>
        <IconButton
          disableRipple
          disableFocusRipple
          style={{ backgroundColor: "transparent" }}
          onClick={this.handleClick}
          disabled={this.isDisabled()}
        >
          <MenuIcon key="menu-icon" color={this.getColor()} />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          keepMounted
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          open={Boolean(this.state.anchorEl)}
          onClose={this.handleClose}
          disableScrollLock
        >
          {menuItems}
        </Menu >
      </>
    );
  }
}
export default ActionMenu;
